function generateSessionSecret() {
  var storageKey = "nexora_session_secret";

  try {
    var existing = localStorage.getItem(storageKey);
    if (existing) return existing;

    var bytes = new Uint8Array(32);

    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i++) {
        bytes[i] = Math.floor(Math.random() * 256);
      }
    }

    var secret = Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, "0");
    }).join("");

    localStorage.setItem(storageKey, secret);
    return secret;
  } catch (e) {
    return "nexora_ws_v1_9f3c8e4b2d14a7c6e1f5b9d3a2c4e8f0";
  }
}

window.generateSessionSecret = window.generateSessionSecret || generateSessionSecret;

(function () {
  "use strict";

  if (window.__NEXORA_SHOPIFY_INIT_STARTED__) return;
  window.__NEXORA_SHOPIFY_INIT_STARTED__ = true;

  var STANDARD_EVENTS = [
    "page_viewed",
    "product_viewed",
    "product_added_to_cart",
    "product_removed_from_cart",
    "cart_viewed",
    "collection_viewed",
    "search_submitted",
    "checkout_started",
    "checkout_completed",
    "payment_info_submitted",
    "checkout_address_info_submitted",
    "checkout_contact_info_submitted",
    "checkout_shipping_info_submitted",
    "customer_logged_in",
    "customer_registered",
    "customer_logged_out",
    "customer_profile_updated"
  ];

  function patchEventBufferSize(nexora) {
    if (!nexora || !nexora.eventBuffer) return;
    if (typeof nexora.eventBuffer.size === "function") return;

    nexora.eventBuffer.size = function () {
      return (
        (this.systemQueue ? this.systemQueue.length : 0) +
        (this.customEventsQueue ? this.customEventsQueue.length : 0) +
        (this.pushNotificationEventsQueue ? this.pushNotificationEventsQueue.length : 0)
      );
    };
  }

  function createPostMessageShopifyBridge(nexora, nexoraShopify, events) {
    events = events || [];

    var processedEvents = {};
    var DEDUPE_TTL_MS = 10000;

    function normalizeEventName(eventName) {
      var aliases = {
        "nexora:customer_logged_in": "customer_logged_in",
        "nexora:customer_registered": "customer_registered",
        "nexora:customer_logged_out": "customer_logged_out",
        "nexora:customer_profile_updated": "customer_profile_updated"
      };

      return aliases[eventName] || eventName;
    }

    function getEventKey(eventName, eventData) {
      return [
        eventName || "",
        eventData && eventData.event_id ? eventData.event_id : "",
        eventData && eventData.id ? eventData.id : "",
        eventData && eventData.user_id ? eventData.user_id : "",
        eventData && eventData.timestamp ? eventData.timestamp : ""
      ].join(":");
    }

    function isDuplicate(eventName, eventData) {
      var key = getEventKey(eventName, eventData || {});
      var now = Date.now();

      Object.keys(processedEvents).forEach(function (existingKey) {
        if (now - processedEvents[existingKey] > DEDUPE_TTL_MS) {
          delete processedEvents[existingKey];
        }
      });

      if (processedEvents[key]) return true;

      processedEvents[key] = now;
      return false;
    }

    function pushEvent(eventName, eventData) {
      return Promise.resolve()
        .then(function () {
          if (nexoraShopify.onShopifyEvent && typeof nexoraShopify.onShopifyEvent === "function") {
            return nexoraShopify.onShopifyEvent(eventName, eventData || {});
          }
        })
        .catch(function (err) {
          console.error("[Nexora] event push failed:", eventName, err);
        });
    }

    // function updateNexoraUser(customer) {
    //   if (!customer || !customer.user_id) return Promise.resolve();

    //   return Promise.resolve()
    //     .then(function () {
    //       if (nexora.user && typeof nexora.user.login === "function") {
    //         return nexora.user.login({
    //           user_id: customer.user_id || customer.id,
    //           email: customer.email,
    //           mobile: customer.mobile || customer.phone,
    //           name: customer.name,
    //           first_name: customer.firstName,
    //           last_name: customer.lastName
    //         });
    //       }
    //     })
    //     .catch(function (err) {
    //       console.error("[Nexora] user update/login failed:", err);
    //     });
    // }

    function track(eventName, eventData) {
      var normalizedEventName = normalizeEventName(eventName);
      var data = eventData || {};

      var now = new Date().toISOString();

      data.timestamp = data.timestamp || now;
      data.event_timestamp = data.event_timestamp || data.timestamp;
      data.occurred_at = data.occurred_at || data.timestamp;

      if (events.indexOf(normalizedEventName) === -1) {
        return Promise.resolve();
      }
      console.log("Passed index of check")
      if (isDuplicate(normalizedEventName, data)) {
        return Promise.resolve();
      }
      
      return Promise.resolve()
        .then(function () {
          return nexoraShopify.onShopifyEvent(normalizedEventName, data);
        })
        .catch(function (err) {
          console.error("[Nexora] Shopify event handling failed:", normalizedEventName, err);
        });
    }

    window.addEventListener("message", function (event) {
      var message = event.data;

      if (!message || message.type !== "SHOPIFY_EVENT") return;

      track(message.eventName, message.data || {});
    });

    return {
      track: track,
      push: pushEvent
    };
  }


  function replayQueuedPixelEvents() {
    if (!window.__NexoraShoppifyInstance__) return;
    var queue = window.__NEXORA_PIXEL_QUEUE__ || [];
    queue.forEach(function (message) {
        if (!message || message.type !== "SHOPIFY_EVENT") return;
        window.__NexoraShoppifyInstance__.track(
            message.eventName,
            message.data || {}
        );
    });

    window.__NEXORA_PIXEL_QUEUE__ = [];

    if (window.__NEXORA_EARLY_PIXEL_LISTENER__) {
        window.removeEventListener("message", window.__NEXORA_EARLY_PIXEL_LISTENER__);
    }
}

  function waitForNexora(timeoutMs) {
    timeoutMs = timeoutMs || 8000;

    return new Promise(function (resolve, reject) {
      if (typeof window.Nexora === "function") {
        resolve();
        return;
      }

      var start = Date.now();
      var timer = setInterval(function () {
        if (typeof window.Nexora === "function") {
          clearInterval(timer);
          resolve();
        } else if (Date.now() - start > timeoutMs) {
          clearInterval(timer);
          reject(new Error("SDK failed to load"));
        }
      }, 100);
    });
  }

  async function init() {
    var cfg = window.__NEXORA_CONFIG__;

    if (!cfg || !cfg.projectId || !cfg.clientId || !cfg.writeKey) {
      console.error("[Nexora] Missing config");
      return;
    }

    try {
      await waitForNexora();

      var nexora = new window.Nexora(
        cfg.clientId,
        cfg.projectId,
        cfg.writeKey,
        {
          login_session_timeout:
            cfg.loginSessionTimeout || { value: 1, metrics: "year" }
        }
      );

      var nexoraShopify = new window.NexoraShopify(nexora, {});

      patchEventBufferSize(nexora);

      window.__NexoraInstance__ = nexora;
      window.__NexoraShoppifyInstance__ = createPostMessageShopifyBridge(
        nexora,
        nexoraShopify,
        STANDARD_EVENTS
      );

      replayQueuedPixelEvents();

      window.dispatchEvent(new CustomEvent("nexora:ready"));

      if (cfg.debug) {
        console.log("[Nexora Shopify] Ready");
      }
    } catch (err) {
      console.error("[Nexora] Initialization failed:", err);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();